import { createAction, props } from '@ngrx/store';
import { User } from '../../core/interfaces/user.interface';

// Login actions
export const login = createAction(
  '[Auth] Login',
  props<{ username: string; password: string }>()
);
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; token: string; refreshToken: string }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

// Logout actions
export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

// Load current user actions
export const loadCurrentUser = createAction('[Auth] Load Current User');
export const loadCurrentUserSuccess = createAction(
  '[Auth] Load Current User Success',
  props<{ user: User }>()
);
export const loadCurrentUserFailure = createAction(
  '[Auth] Load Current User Failure',
  props<{ error: string }>()
);

// Set user from token (when app starts)
export const setUserFromToken = createAction(
  '[Auth] Set User From Token',
  props<{ user: User }>()
);

// Update current user actions
export const updateCurrentUser = createAction(
  '[Auth] Update Current User',
  props<{ user: User }>()
);

export const updateCurrentUserSuccess = createAction(
  '[Auth] Update Current User Success',
  props<{ user: User }>()
);

export const updateCurrentUserFailure = createAction(
  '[Auth] Update Current User Failure',
  props<{ error: string }>()
);

// Force password change actions
export const forcePasswordChange = createAction(
  '[Auth] Force Password Change',
  props<{ resetPasswordToken: string; user: User; token: string }>()
);

export const forcePasswordChangeSuccess = createAction(
  '[Auth] Force Password Change Success'
);

export const forcePasswordChangeFailure = createAction(
  '[Auth] Force Password Change Failure',
  props<{ error: string }>()
);

// Clear error
export const clearAuthError = createAction('[Auth] Clear Error');
